import './turbotrucks.svg';
import './th-group.svg';

import './shared/branches_map/geo.svg';

import './shared/delivery/avtotreyding.jpg';
import './shared/delivery/airtranss.jpg';
import './shared/delivery/azimut.png';
import './shared/delivery/alfa.png';
import './shared/delivery/albatros.jpg';
import './shared/delivery/baikal-servis.png';
import './shared/delivery/bsd.png';
import './shared/delivery/dl.jpg';
import './shared/delivery/jde.png';
import './shared/delivery/kse.jpg';
import './shared/delivery/nv-express.gif';
import './shared/delivery/pek.jpg';
import './shared/delivery/ratek.png';
import './shared/delivery/rc.jpg';
import './shared/delivery/sdek.jpg';
import './shared/delivery/sherl.jpg';
import './shared/delivery/uraltrans.png';
import './shared/delivery/uts.png';
import './shared/delivery/cap.jpg';

import './shared/suppliers/AUGER.jpg';
import './shared/suppliers/BEHRHELLA.jpg';
import './shared/suppliers/BORGWARNER.jpg';
import './shared/suppliers/COJALI.jpg';
import './shared/suppliers/COVIND.jpg';
import './shared/suppliers/DAF.jpg';
import './shared/suppliers/DIESELTECHNIC.jpg';
import './shared/suppliers/DINEX.jpg';
import './shared/suppliers/DONALDSON.jpg';
import './shared/suppliers/DONGFENG.jpg';
import './shared/suppliers/EBS.jpg';
import './shared/suppliers/ENERGIZER.jpg';
import './shared/suppliers/EURORICAMBI.jpg';
import './shared/suppliers/FEBI.jpg';
import './shared/suppliers/GARRETT.jpg';
import './shared/suppliers/HOLSET.jpg';
import './shared/suppliers/JOHNSONCONTROLS.jpg';
import './shared/suppliers/NRF.jpg';
import './shared/suppliers/OEGERMANY.jpg';
import './shared/suppliers/TANGDE.jpg';
import './shared/suppliers/VARTA.jpg';
import './shared/suppliers/WEBASTO.jpg';
import './shared/suppliers/ZF_LEMFRDER.jpg';
import './shared/suppliers/ZF_SACHS.jpg';
import './shared/suppliers/ZF.jpg';

import './shared/suppliers/no-image.png';

import './signatures/serg.png';
import './signatures/stamp.png';
import './signatures/vasilenko.png';

import './promo/black_friday_2019/truck.png';
import './promo/black_friday_2019/part1.png';
import './promo/black_friday_2019/part2.png';

import './varta/AKB_Banner_698x310.png';
import './varta/AKB_Banner_698x280.png';
import './varta/BG_Auto.jpg';
import './varta/VARTA_Promotive_Black_470x520.png';
import './varta/VARTA_Promotive_Blue_470x520.png';
import './varta/VARTA_Promotive_EFB_470x520.png';
import './varta/VARTA_Promotive_Silver_470x520.png';
import './varta/Varta_Properties.png';

import './turbochargers/01.png'
import './turbochargers/02.png'
import './turbochargers/03.png'
import './turbochargers/04.png'
import './turbochargers/05.png'
import './turbochargers/BorgWarner.jpg'
import './turbochargers/Garrett.jpg'
import './turbochargers/Holset.jpg'
import './turbochargers/KKK.jpg'
import './turbochargers/turbo.png'
import './turbochargers/turbo2.png'
import './turbochargers/turbo3.png'
import './turbochargers/Top_Turbocharger.jpg'

import './clutch_kits/clutch_disc.jpg'
import './clutch_kits/KAWE.jpg'
import './clutch_kits/RUEN.jpg'
import './clutch_kits/SACHS.jpg'
import './clutch_kits/TRP.jpg'

import './nrf/NRF_1980x400_1.jpg'
import './nrf/nrf2.png'

import './promo/energizer/notification.png';
